export const LIST_CONTACT = 'LIST_CONTACT';
export const LIST_CONTACT_SUCCESS = 'LIST_CONTACT_SUCCESS';
export const LIST_CONTACT_ERROR = 'LIST_CONTACT_ERROR';